module.exports = __webpack_public_path__ + "pdf/specialities.d02ec4b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/specialities.pdf
// module id = qob7
// module chunks = 0